import { render } from "./ConfirmDialog.vue?vue&type=template&id=1ed6add2&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=1ed6add2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed6add2"]])

export default __exports__